<template>
    <b-nav vertical pills class="mv-nav-sidebar">
        <template v-for="item in group">
            <template v-if="item.show !== false && item.external !== true">
                <b-nav-item :key="item._links.self.href" :to="item.slug">{{item.title}}</b-nav-item>
            </template>
          <template v-if="item.show !== false && item.external === true">
            <b-nav-item :key="item._links.self.href" :href="item.slug">{{item.title}}</b-nav-item>
          </template>
        </template>
    </b-nav>
</template>

<script>
import "./NavSidebar.scss";
export default {
    name: "NavSidebar",
    computed: {
        group() {
            var menu = this.$store.getters.getMenu;
            var currentPage = this.$store.getters.getCurrentPage;
            var currentPageGroup = "";

            Object.keys(menu).forEach(key => {
                menu[key].forEach(element => {
                    if (element.slug === currentPage) {
                        currentPageGroup = element.group;
                    }
                });
            });
            return menu[currentPageGroup];
        }
    }
};
</script>